import graphqlApi from '../api/graphqlApi';
import {
    createShopifyCart,
    shopifyAddNewProductsToCart,
    shopifyCartAttributesUpdate,
    shopifyCartLineRemove,
    shopifyUpdateCartLines,
} from './queries/shopifyCart';
import {
    CartAttributesUpdateResp,
    CartCreateResp,
    CartInput,
    CartLineInput,
    CartLinesAddResp,
    CartLinesRemoveResp,
    CartLinesUpdateResp,
} from '../../models/ShopifyCartShema';
import storageService, { Locals } from '../../utils/storageService';

const useShopifyCart = () => {
    const cart_token = storageService.getItem(Locals.CART_TOKEN);

    const createNewShopifyCart = (
        input: CartInput
    ): Promise<CartCreateResp> => {
        return graphqlApi
            .post(createShopifyCart(), { input })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                throw error;
            });
    };

    const addNewProductToShopifyCart = (
        lines: CartLineInput[]
    ): Promise<CartLinesAddResp> => {
        return graphqlApi
            .post(shopifyAddNewProductsToCart(), {
                cartId: cart_token,
                lines: lines,
            })
            .then((res) => {
                if (
                    res.cartLinesAdd.userErrors &&
                    res.cartLinesAdd.userErrors.length > 0
                ) {
                    throw res.userErrors;
                }
                return res;
            })
            .catch((error) => {
                throw error;
            });
    };

    const updateCartItem = (
        lines: { id: string; quantity: number }[]
    ): Promise<CartLinesUpdateResp> => {
        return graphqlApi
            .post(shopifyUpdateCartLines(), {
                cartId: cart_token,
                lines: lines,
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                throw error;
            });
    };

    const removeCartItem = (
        lineIds: string[]
    ): Promise<CartLinesRemoveResp> => {
        return graphqlApi
            .post(shopifyCartLineRemove(), {
                cartId: cart_token,
                lineIds: lineIds,
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                throw error;
            });
    };

    const updateAttributes = (
        attributes: { key: string; value: string }[]
    ): Promise<CartAttributesUpdateResp> => {
        return graphqlApi
            .post(shopifyCartAttributesUpdate(), {
                cartId: cart_token,
                attributes: attributes,
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                throw error;
            });
    };

    return {
        createNewShopifyCart,
        addNewProductToShopifyCart,
        updateCartItem,
        removeCartItem,
        updateAttributes,
    };
};

export default useShopifyCart;
